<template>
  <div class="network" v-on:click="changeNetwork" v-tooltip.top="$t('tooltips.network')">
    <span v-bind:class="{'network-item--active': network}">{{ $t('header.network_lora') }}</span>
      /
    <span v-bind:class="{'network-item--active': !network}">{{ $t('header.network_sigfox') }}</span>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'Network',
  watch: {
    value() {
      this.isDirty = true;
      if (this.value.length === 0) {
        this.showHelp = false;
      }
      this.emitSearchText();
    },
  },
  computed: {
    ...mapGetters('tentacle', ['network']),
  },
  methods: {
    changeNetwork() {
      const toggleValue = !this.$store.getters['tentacle/network'];
      this.$store.dispatch('tentacle/setNetwork', toggleValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.network {
  font-size: 1.4em;
  color: #9b9b9b;
  padding: 0.25em 2em;
  //border-right: 0.1rem solid #eee;
  margin: 0 1em;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  letter-spacing: 0.25px;

  &:hover {
    margin-top: 1px;
    padding: 0.5em 2em;
    background: #f8f8f8;
    border-radius: 0.5em;
    //border-right: 0.1rem solid transparent;
  }

  &:active {
    background: white;
  }

  span {
    transition: color 0.05s linear;
    width: 1em;
  }

  &-item--active {
    font-weight: bold;
    color: $company-color-light;
  }
}
</style>
